/* Dezine Kids v2.6 — collection runtime bug fixes
   1. Avone freeShippMsg() expects routes.url; map it to the cart route.
   2. Avone still calls removed priceSlider(); the custom slider is restored by restoreFiltersState().
*/
(function () {
  window.routes = window.routes || {};

  if (!window.routes.url) {
    var cartUrl = window.routes.cart_url || '/cart';
    window.routes.url = String(cartUrl).replace(/\/+$/, '');
  }

  if (typeof window.priceSlider !== 'function') {
    window.priceSlider = function () {};
  }
})();
